// Calendar.jsx
import React from 'react';
import styles from '../../styles/calendar/Calendar.module.scss';
import CalendarCells from './CalendarCells';
import CalendarDays from './CalendarDays';
import CalendarHeader from './CalendarHeader';

const Calendar = ({ children, containerStyles }) => {
  return (
    <div
      className={
        styles[`${containerStyles ? containerStyles : 'calendarContainer'}`]
      }>
      {children ? (
        children
      ) : (
        <>
          <CalendarHeader />
          <CalendarDays />
          <CalendarCells />
        </>
      )}
    </div>
  );
};

Calendar.Header = CalendarHeader;
Calendar.Days = CalendarDays;
Calendar.Cells = CalendarCells;

export default Calendar;
